import { render } from "./LesRecollections.vue?vue&type=template&id=6d7b4e1b&scoped=true&ts=true"
import script from "./LesRecollections.vue?vue&type=script&lang=ts"
export * from "./LesRecollections.vue?vue&type=script&lang=ts"

import "./LesRecollections.vue?vue&type=style&index=0&id=6d7b4e1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7b4e1b"]])

export default __exports__